module.exports = __webpack_public_path__ + "static/media/login-bg-7.adc805ae.jpg";